import queries from '@apis/queries';
import { datadogRum } from '@datadog/browser-rum';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useGiftOrder(giftOrderNo: string) {
  const { data, status } = useQuery(queries.giftOrder.detail(giftOrderNo));
  const { replace } = useFlow();
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('선물하기 주문 정보를 불러오지 못했습니다.');
      replace('MainActivity', {});
    } else if (import.meta.env.MODE !== 'development' && status === 'success') {
      datadogRum.addAction('giftOrderComplete', {
        giftOrderNo,
      });
    }
  }, [status]);
  return data;
}

export default useGiftOrder;
